var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionMindBlowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2039 18.9832C49.2834 17.5004 41.2766 14.4295 40.6131 14.0073L27.193 21.4712L29.3795 26.1457L44.2321 27.6536C48.1777 26.4473 56.1594 23.9894 56.5213 23.8085C56.8832 23.6275 54.4605 20.5162 53.2039 18.9832Z",
    fill: "#F7DED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 33.0137L19.1328 37.5137L39.6328 63.5137L61.1328 38.0137L60.1328 36.0137L58.1328 37.5137L56.1328 34.0137L53.6328 35.0137L50.1328 33.0137L47.1328 36.5137L45.1328 35.0137L42.1328 35.5137L39.6328 39.0137L36.6328 32.0137L34.6328 39.5137L30.1328 32.5137L28.6328 33.5137L27.1328 32.0137H23.6328V36.0137L22.6328 33.5137L21.1328 33.0137Z",
    fill: "#A9D7DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2867 27.5137H45.979C45.8383 32.5908 46.2094 35.6701 48.0766 38.6205L48.1328 38.812H40.6328H33.1328L33.1891 38.6205C35.0562 35.6701 35.4273 32.5908 35.2867 27.5137Z",
    fill: "#F7DED9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9703 29.7883C25.642 29.7883 27.8078 27.6225 27.8078 24.9508C27.8078 22.2791 25.642 20.1133 22.9703 20.1133C20.2986 20.1133 18.1328 22.2791 18.1328 24.9508C18.1328 27.6225 20.2986 29.7883 22.9703 29.7883Z",
    fill: "#F7DED9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2201 27.6379C58.4855 27.6379 61.1326 25.4721 61.1326 22.8004C61.1326 20.1287 58.4855 17.9629 55.2201 17.9629C51.9547 17.9629 49.3076 20.1287 49.3076 22.8004C49.3076 25.4721 51.9547 27.6379 55.2201 27.6379Z",
    fill: "#F7DED9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4957 29.7883C33.1674 29.7883 35.3332 27.6225 35.3332 24.9508C35.3332 22.2791 33.1674 20.1133 30.4957 20.1133C27.824 20.1133 25.6582 22.2791 25.6582 24.9508C25.6582 27.6225 27.824 29.7883 30.4957 29.7883Z",
    fill: "#F7DED9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6205 29.8637C49.8859 29.8637 52.533 27.9385 52.533 25.5637C52.533 23.1888 49.8859 21.2637 46.6205 21.2637C43.3551 21.2637 40.708 23.1888 40.708 25.5637C40.708 27.9385 43.3551 29.8637 46.6205 29.8637Z",
    fill: "#F7DED9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0951 31.9387C42.3605 31.9387 45.0076 29.7728 45.0076 27.1012C45.0076 24.4295 42.3605 22.2637 39.0951 22.2637C35.8297 22.2637 33.1826 24.4295 33.1826 27.1012C33.1826 29.7728 35.8297 31.9387 39.0951 31.9387Z",
    fill: "#F7DED9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1705 19.0387C42.8422 19.0387 45.008 17.3541 45.008 15.2762C45.008 13.1982 42.8422 11.5137 40.1705 11.5137C37.4988 11.5137 35.333 13.1982 35.333 15.2762C35.333 17.3541 37.4988 19.0387 40.1705 19.0387Z",
    fill: "#F7DED9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6328 20.5137C53.5658 20.5137 55.1328 19.1705 55.1328 17.5137C55.1328 15.8568 53.5658 14.5137 51.6328 14.5137C49.6998 14.5137 48.1328 15.8568 48.1328 17.5137C48.1328 19.1705 49.6998 20.5137 51.6328 20.5137Z",
    fill: "#F7DED9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7326 23.3395C29.1074 23.3395 31.0326 21.6549 31.0326 19.577C31.0326 17.499 29.1074 15.8145 26.7326 15.8145C24.3578 15.8145 22.4326 17.499 22.4326 19.577C22.4326 21.6549 24.3578 23.3395 26.7326 23.3395Z",
    fill: "#F7DED9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7953 23.3391C38.0607 23.3391 40.7078 21.1732 40.7078 18.5016C40.7078 15.8299 38.0607 13.6641 34.7953 13.6641C31.5299 13.6641 28.8828 15.8299 28.8828 18.5016C28.8828 21.1732 31.5299 23.3391 34.7953 23.3391Z",
    fill: "#F7DED9"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1360_12991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4125 23.3393C48.6779 23.3393 51.325 21.1735 51.325 18.5018C51.325 15.8301 48.6779 13.6643 45.4125 13.6643C42.1471 13.6643 39.5 15.8301 39.5 18.5018C39.5 21.1735 42.1471 23.3393 45.4125 23.3393Z",
    fill: "#F7DED9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0928 64.5137C52.5192 64.5137 62.5928 54.4401 62.5928 42.0137C62.5928 40.6934 62.4791 39.3996 62.2609 38.1417L61.1328 37.0137L59.1328 37.5137L54.1328 34.0137L52.6328 35.0137L52.1328 33.5137L50.1328 35.0137L49.1328 34.0137L47.6328 35.0137L42.6328 37.5137L41.1328 36.0137L39.6328 38.5137L37.6328 37.5137L36.1328 38.5137L35.6328 36.0137H34.1328L33.6328 34.0137H32.1328L28.6328 37.5137L27.1328 36.0137L25.6328 37.0137L24.6328 35.5137L22.1328 34.0137L21.1328 40.0137L20.6328 35.0137H18.703C17.9824 37.2168 17.5928 39.5698 17.5928 42.0137C17.5928 54.4401 27.6664 64.5137 40.0928 64.5137Z",
    fill: "#D6ECF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2685 38.1856C62.4817 39.4297 62.5928 40.7087 62.5928 42.0136C62.5928 54.44 52.5192 64.5136 40.0928 64.5136C27.6664 64.5136 17.5928 54.44 17.5928 42.0136C17.5928 39.5749 17.9808 37.2267 18.6984 35.0276",
    stroke: "#A9D7DF",
    strokeWidth: 0.73,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 43.5137C34.1328 45.1705 33.2374 46.5137 32.1328 46.5137C31.0282 46.5137 30.1328 45.1705 30.1328 43.5137C30.1328 41.8568 31.0282 40.5137 32.1328 40.5137C33.2374 40.5137 34.1328 41.8568 34.1328 43.5137Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1328 43.5137C51.1328 45.1705 50.2374 46.5137 49.1328 46.5137C48.0282 46.5137 47.1328 45.1705 47.1328 43.5137C47.1328 41.8568 48.0282 40.5137 49.1328 40.5137C50.2374 40.5137 51.1328 41.8568 51.1328 43.5137Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9757 50.4512C36.9623 50.4512 35.5807 52.6787 35.1703 54.5424C35.0216 55.218 35.7068 55.7177 36.3742 55.5356C37.5526 55.2139 39.3249 54.8228 40.9757 54.8228C42.6266 54.8228 44.3988 55.2139 45.5773 55.5356C46.2447 55.7177 46.9299 55.218 46.7812 54.5424C46.3708 52.6787 44.9892 50.4512 40.9757 50.4512Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7197 11.6489L47.5299 17.6786L50.065 16.1893L49.8426 12.2721L46.7197 11.6489ZM20.4464 17.6072L22.8395 14.0498L20.3624 15.3778L18.5981 17.7388L20.4464 17.6072ZM12.6328 30.0137L15.1328 35.0137L15.6328 31.5137L14.1328 28.0137L12.6328 30.0137ZM12.6328 24.0137L12.1328 21.7837L16.541 17.5137L15.1327 20.5143L16.5408 21.7837L15.6328 23.5137L12.6328 24.0137ZM62.4811 29.7126L59.8928 28.033L57.2605 30.1128L57.9307 32.125L60.5639 32.4663L61.8984 35.8652L62.4811 29.7126ZM48.5439 27.0604L52.0761 24.9507L53.9686 30.8822L48.5753 31.5881L47.132 33.9981L46.1615 27.305L48.5439 27.0604Z",
    fill: "#D6E9F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1360_12991",
    x: 18.1328,
    y: 20.1133,
    width: 9.67505,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1360_12991",
    x: 49.3076,
    y: 17.9629,
    width: 11.825,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1360_12991",
    x: 25.6582,
    y: 20.1133,
    width: 9.67505,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1360_12991",
    x: 40.708,
    y: 21.2637,
    width: 11.825,
    height: 8.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1360_12991",
    x: 33.1826,
    y: 22.2637,
    width: 11.825,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1360_12991",
    x: 35.333,
    y: 11.5137,
    width: 9.67505,
    height: 7.5249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1360_12991",
    x: 48.1328,
    y: 14.5137,
    width: 7,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1360_12991",
    x: 22.4326,
    y: 15.8145,
    width: 8.59998,
    height: 7.5249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1360_12991",
    x: 28.8828,
    y: 13.6641,
    width: 11.825,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1360_12991",
    x: 39.5,
    y: 13.6643,
    width: 11.825,
    height: 9.67505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1360_12991"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionMindBlowing);
export default __webpack_public_path__ + "static/media/reaction_mind-blowing.fda2c2954919cd4f10babf006d2a1a3a.svg";
export { ForwardRef as ReactComponent };